import { render, staticRenderFns } from "./SkeletonRankingList.vue?vue&type=template&id=42cfe388"
import script from "./SkeletonRankingList.vue?vue&type=script&lang=js"
export * from "./SkeletonRankingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports